import PdfPreview from "../../ui/PdfPreview"
interface SavedClaimBoxProps {
  claim: {
    euipoDocumentId?: string
    originalFileName?: string
    attachmentFile?: File | null
    _id?: string
    type?: string

    office?: string
    countryCode?: string

    filingNumber?: string | null
    applicationNumber?: string | null
    registrationNumber?: string | null

    filingDate?: string | null
    applicationDate?: string | null
    registrationDate?: string | null

    markName?: string
  }

  onEdit: () => void
  onDelete: () => void
}

export default function SavedClaimBox({
  claim,
  onEdit,
  onDelete
}: SavedClaimBoxProps) {

  const isPriority = claim.type === "priority"

  const title =
    isPriority
      ? "Priority claim"
      : "Seniority claim"

  const number =
    claim.filingNumber ||
    claim.registrationNumber ||
    claim.applicationNumber ||
    "-"

  const office =
    claim.office ||
    claim.countryCode ||
    "-"

  const date =
    claim.registrationDate ||
    claim.applicationDate ||
    claim.filingDate ||
    null

  const formattedDate =
    date
      ? new Date(date).toLocaleDateString("de-DE")
      : "-"

  return (

    <div className="border border-gray-300 rounded-md w-60 h-28 p-3 bg-white flex flex-col justify-between">

      <div>

        <p className="font-medium text-sm text-gray-800 truncate">
          {title}
        </p>

        <p className="text-xs text-gray-600 truncate">
          {number} | {office} | {formattedDate}
        </p>

      </div>

      <div className="flex justify-between text-xs mt-2">
        <PdfPreview file={claim.attachmentFile} documentId={claim.euipoDocumentId} fileName={claim.originalFileName} />

        <button
          onClick={onEdit}
          className="text-blue-600 hover:underline font-medium"
        >
          Edit
        </button>

        <button
          onClick={onDelete}
          className="text-red-600 hover:underline font-medium"
        >
          Delete
        </button>

      </div>

    </div>

  )

}